export default "__VITE_ASSET__C2WsMm7G__"